module.exports = __webpack_public_path__ + "files/48598e4c8868b5c9127b051e650b2bb3.svg";